<template>
  <div
    class="feeling-lucky-wrapper wrapper"
    :class="{'wrapper--sideways': $route.name === 'SpeakerText' && (mediaQueryIs === 'mobile' || mediaQueryIs === 'tablet')}"
  >
    <div
      class="random-speaker"
      :class="{'random-speaker--sideways': $route.name === 'SpeakerText' && (mediaQueryIs === 'mobile' || mediaQueryIs === 'tablet')}"
    >
      <div class="back">
        <div class="mobile-only">
          <button class="back-btn" type="button" @click="backFn">
            <span class="sr-only">Back</span>
            <img src="/images/left-chevron.png" alt>
          </button>
        </div>
        <div class="desktop-only">
          <button @click="backFn" class="btn btn--left">Back</button>
        </div>
      </div>
      <div class="mobile-text-entry" v-if="$route.name === 'SpeakerText'">
        <ConfigureText feelingLucky :show-apply-buttons="false"/>
        <p class="mobile-text-instructions">Finish it up with text, or leave it blank.</p>
      </div>

      <div class="speaker-wrapper">
        <div
          class="speaker"
          :class="{ 'speaker--text': $route.name === 'SpeakerText' && (mediaQueryIs === 'mobile' || mediaQueryIs === 'tablet')}"
        >
          <div class="config-canvas-equalizer">
            <router-view name="speaker" :onClick="randomConfig" :text="buttonText"/>
          </div>
        </div>
      </div>
    </div>
    <router-view name="description" :speakerId="speakerId"/>
  </div>
</template>

<script>
import Button from "../components/Button.vue";
import ConfigureText from "@/components/configure/Text.vue";
import store from "../store";

let resizeTimeout = null;
// run once

function resizeThrottler(routeName, mediaQueryIs) {
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(function() {
      resizeTimeout = null;
      actualResizeHandler(routeName, mediaQueryIs);

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

function actualResizeHandler(routeName, mediaQueryIs) {
  const divToResize = document.querySelector(".speaker");
  // const divToGetHeightOf = document.querySelector(".canvas-wrapper");
  let wid = $(divToResize).height() - 80;
  if (
    window.innerWidth >= 992 ||
    (routeName === "SpeakerText" &&
      (mediaQueryIs === "mobile" || mediaQueryIs === "tablet"))
  ) {
    $(divToResize).attr("style", "");
  } else {
    $(divToResize).width(wid);
  }
}

export default {
  name: "feeling-lucky",
  components: { ConfigureText },
  data: function() {
    return {
      feelingLuckyOptions: [],
      mediaQueryIs: null,
      started: false,
      isMobile: null,
      leftSpeaker: {
        Filename: "/images/left.png"
      },
      rightSpeaker: {
        Filename: "images/right.png"
      }
    };
  },
  created() {
    const that = this;
    mediaCheck({
      media: "(max-width: 767px)",
      entry: function() {
        that.mediaQueryIs = "mobile";
      }
    });
    mediaCheck({
      media: "(min-width: 768px) and (max-width: 991px)",
      entry: function() {
        that.mediaQueryIs = "tablet";
      }
    });
    mediaCheck({
      media: "(min-width: 992px)",
      entry: function() {
        that.mediaQueryIs = "desktop";
      }
    });
    $(document).ready(function() {
      actualResizeHandler(that.$route.name, that.mediaQueryIs);
      window.addEventListener(
        "resize",
        () => resizeThrottler(that.$route.name, that.mediaQueryIs),
        false
      );
    });
    document.querySelector("html").classList.add("full-page");
    document.querySelector("html").classList.add("html--feeling-lucky");
    store.commit("updateLuckyCountTo", 0);
    // If we land on /feeling-lucky/#, we pull that id # out and make that the first item in the randomized array of options
    var speakerId = parseInt(this.$route.params.id);
    var speakerIdValid = store.state.feelingLucky.find(
      fl => fl.Id === speakerId
    );

    if (this.$route.name === "SpeakerText") {
      if (this.$route.params.id) {
        const config = this.$store.state.feelingLucky.find(
          fl => fl.Id === parseInt(this.$route.params.id)
        );
        this.$store.commit("selectOption", {
          CategoryName: "Fabric",
          Id: config.Fabric
        });
        this.$store.commit("selectOption", {
          CategoryName: "Caps",
          Id: config.Caps
        });
        this.$store.commit("selectOption", {
          CategoryName: "Spine",
          Id: config.Spine
        });
        this.$store.commit("selectOption", {
          CategoryName: "Icon",
          Id: config.Icon
        });
        this.$store.commit("selectOption", {
          CategoryName: "Loop",
          Id: config.Loop
        });
      }
    }

    if (speakerId && speakerIdValid) {
      // randomizes the array
      let feelingLuckyOptions = [];
      feelingLuckyOptions = this.organizeArray(store.state.feelingLucky);

      // this is where the current page is in the array
      var location = feelingLuckyOptions.findIndex(function(item) {
        return item.Id === speakerId;
      });

      // we splice the current item out of the array and then place it at the beginning
      var currentItem = feelingLuckyOptions.splice(location, 1);

      feelingLuckyOptions.unshift(currentItem[0]);

      store.commit("setFeelingLuckyOrder", feelingLuckyOptions);

      this.started = true;
    } else if (speakerId && !speakerIdValid) {
      // not a valid speaker id, go back to homepage
      this.$router.push({ name: 'home' });
    } else {
      store.commit(
        "setFeelingLuckyOrder",
        this.organizeArray(store.state.feelingLucky)
      );
    }
  },
  beforeDestroy() {
    document.querySelector("html").classList.remove("html--feeling-lucky");
  },
  methods: {
    checkIfMobile() {
      return this.isMobile;
    },
    backFn() {
      // go back to homepage
      this.$router.go(-1);
    },
    randomConfig: function(event) {
      if (!this.started) {
        store.commit(
          "setFeelingLuckyOrder",
          this.organizeArray(store.state.feelingLucky)
        );
        this.$data.started = true;
      }
      // as long as this isn't the last item...
      if (
        parseInt(this.$route.params.id) !==
        this.computedFeelingLuckyOptions.length
      ) {
        const currentIndex = this.computedFeelingLuckyOptions.findIndex(
          fl => fl.Id === parseInt(this.$route.params.id)
        );
        var urlId = this.computedFeelingLuckyOptions[currentIndex + 1].Id;
        this.$router.push({ name: "SpeakerChoices", params: { id: urlId } });
      }
    },
    randomizeArray: function(array) {
      var currentIndex = array.length,
        temporaryValue,
        randomIndex;

      // While there remain elements to shuffle...
      while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;
    },
    organizeArray: function(array) {
      // randomize the array but make sure the last item is always last (because it has special "that was our last :(" text)
      var organizedArray, arrCopy, lastItem, firstItem;
      arrCopy = array.slice();
      lastItem = arrCopy.pop();
      firstItem = arrCopy.shift();
      organizedArray = this.randomizeArray(arrCopy);
      organizedArray.push(lastItem);
      organizedArray.unshift(firstItem);
      return organizedArray;
    }
  },
  beforeRouteUpdate(to, from, next) {
    const that = this;
    next();
    actualResizeHandler(to.name, that.mediaQueryIs);
  },
  watch: {
    $route(to, from) {
      const that = this;
      setTimeout(() => actualResizeHandler(to.name, that.mediaQueryIs), 0);
    },
    "$route.params.id"(to, from) {
      const currentIndex = this.computedFeelingLuckyOptions.findIndex(
        fl => fl.Id === parseInt(from)
      );
      const nextIndex = this.computedFeelingLuckyOptions.findIndex(
        fl => fl.Id === parseInt(to)
      );
      if (nextIndex > currentIndex) {
        store.commit("updateLuckyCountTo", store.state.luckyCount + 1);
      } else {
        store.commit("updateLuckyCountTo", store.state.luckyCount - 1);
      }
    }
  },
  computed: {
    luckyCount() {
      return this.$store.state.luckyCount;
    },
    computedFeelingLuckyOptions: {
      get: function() {
        return store.state.feelingLuckyRandomized;
      },
      set: function(newVal) {
        store.commit("setFeelingLuckyOrder", newVal);
      }
    },
    buttonText() {
      if (this.computedFeelingLuckyOptions[this.luckyCount]) {
        return this.computedFeelingLuckyOptions[this.luckyCount].Text;
      }
      return "";
    },
    speakerId() {
      if (this.computedFeelingLuckyOptions[this.luckyCount]) {
        return this.computedFeelingLuckyOptions[this.luckyCount].Id;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../scss/variables";

.wrapper {
  max-width: 1280px;
  height: 100%;
  padding-top: 80px;
  padding-bottom: 2em;
  margin-left: auto;
  margin-right: auto;
  padding-left: 1.5em;
  padding-right: 1.5em;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  &--sideways {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 75px;
    padding-left: 2.5em;
    padding-right: 2.5em;
    @media (min-height: 660px) {
      justify-content: center;
    }
  }
  @media (min-width: 992px) {
    padding: 95px 2em 2em;
    flex-direction: row;
  }
}

.config-canvas-equalizer {
  @media (max-width: 991px) {
    height: calc(50vh + 75px);
    width: 0;
    padding-right: 80.39407%;
    position: relative;
    .speaker--text & {
      position: absolute;
    }

    left: 0;
    top: 0;
    margin: auto;
    > * {
      height: 100%;
      width: 100%;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      align-items: center;
    }
  }
  @media (min-width: 992px) {
    height: calc(50vh + 75px);
    width: 0;
    padding-right: 80.39407%;
    position: relative;
    margin: auto;
    > * {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
  }
}

.speaker-wrapper {
  position: relative;

  .random-speaker--sideways & {
    max-width: 85%;
    margin-left: auto;
    margin-right: auto;
    @media (min-width: 700px) {
      max-width: 600px;
      width: 85%;
    }
  }

  @media (min-width: 992px) {
    width: calc(100% - 92px);
  }
}

.random-speaker {
  // margin-bottom: 1em;
  @media (max-width: 991px) {
    height: calc(100% - 130px);
  }

  &--sideways {
    margin-bottom: 2.75em;
    @media (min-width: 400px) {
      margin-bottom: 5em;
    }
    @media (max-width: 991px) {
      height: auto;
    }
    .speaker-wrapper {
      // @media (min-width: 601px) and (max-width: 991px) {
      //   max-width: 600px;
      //   margin-left: auto;
      //   margin-right: auto;
      //}
    }
  }

  @media (min-width: 992px) {
    position: static;
    margin-bottom: 0;
    width: 60%;
    margin-right: 50px;
    margin-left: auto;
    display: flex;
    width: 45%;
    @media (min-height: 700px) {
      width: 50%;
    }
    @media (min-height: 800px) {
      width: 60%;
    }
  }
  @media (min-width: 1200px) {
    margin-right: 100px;
    width: 45%;
    @media (min-height: 700px) {
      width: 50%;
    }
    @media (min-height: 800px) {
      width: 60%;
    }
  }
}

.mobile-text-instructions {
  max-width: 400px;
  font-family: sans-serif;
  font-size: 0.9em;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.3;
  color: $greyDark;
  text-align: center;
  padding-left: 1.5em;
  padding-right: 1.5em;
  margin-bottom: 1rem;
  @media (min-width: 400px) {
    margin-bottom: 3.1rem;
  }
}

.mobile-text-entry,
.mobile-text-instructions {
  @media (min-width: 992px) {
    display: none;
  }
}

.speaker {
  width: 100%;
  height: 100%;
  .wrapper--sideways & {
    height: auto;
  }
  @media (max-width: 991px) {
    max-width: 100%;
    width: 95%;
    margin-left: auto;
    margin-right: auto;
  }
  @media (min-width: 992px) {
    height: 100%;
  }
  &--text {
    @media (max-width: 991px) {
      height: 0;
      padding-bottom: 40%;
      position: relative;
      margin: 0;
    }
    &:after {
      content: "Back";
      display: block;
      position: absolute;
      top: calc(100% + 1em);
      text-align: center;
      color: $greyMidDark;
      text-transform: uppercase;
      font-size: 0.8em;
      left: 0;
      right: 0;
      @media (min-width: 992px) {
        content: none;
      }
    }
  }
}

.back {
  position: absolute;
  top: 50%;
  z-index: 1;
  transform: translateY(-50%);

  .random-speaker--sideways & {
    top: 250px;
    left: 1em;
    @media (min-width: 400px) {
      top: 225px;
    }
    @media (min-width: 700px) {
      top: 50%;
    }
  }

  @media (min-width: 992px) {
    position: static;
    float: left;
    width: 92px;
    padding-top: 0;
    transform: translateY(0);

    @media (min-height: 600px) {
      padding-top: 40px;
    }
    @media (min-height: 900px) {
      padding-top: 100px;
    }
  }

  @media (min-width: 1200px) {
    padding-top: 0;

    @media (min-height: 600px) {
      padding-top: 40px;
    }
    @media (min-height: 900px) {
      padding-top: 100px;
    }
  }
}

.back-btn {
  background: transparent none;
  border: none;
  padding: 0.5em 0.5em 0.5em 0;
  cursor: pointer;
  img {
    max-width: 15px;
  }
}
</style>